export default {
  GET_CART: '/wcs/resources/store/{storeId}/cart/@self/',
  GET_WISHLIST: '/wcs/resources/store/{storeId}/catalog/{catalogId}/saveditems/@self',
  GET_ESPOT: '/wcs/resources/store/{storeId}/espot/',
  PRODUCT_URL: '/wcs/resources/store/{storeId}/productview/byId/',
  ADD_FRAME_TO_CART: '/wcs/resources/store/{storeId}/cart/addFrame/',
  ADD_CONTACTS_TO_CART: '/wcs/resources/store/{storeId}/cart/addContactLenses/',
  DELETE_ITEM_FROM_WISHLIST:
    '/wcs/resources/store/{storeId}/catalog/{catalogId}/saveditems/@self/byId/{savedItemId}',
  GET_PRESCRIPTION: '/wcs/resources/store/{storeId}/prescription/orders',
  EDIT_SAVED_ITEMS_CONTACT_QUANTITY:
    '/wcs/resources/store/{storeId}/catalog/{catalogId}/saveditems/@self/byId/{savedItemId}/quantity',
  EDIT_SAVED_ITEMS_GLASSES_WARRANTY:
    '/wcs/resources/store/{storeId}/catalog/{catalogId}/saveditems/@self/byId/{savedItemId}/warranty',
};
